function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 1792 1792"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M941 1299l454-454q19-19 19-45t-19-45l-102-102q-19-19-45-19t-45 19L896 960 589 653q-19-19-45-19t-45 19L397 755q-19 19-19 45t19 45l454 454q19 19 45 19t45-19zm723-403q0 209-103 385.5T1281.5 1561 896 1664t-385.5-103T231 1281.5 128 896t103-385.5T510.5 231 896 128t385.5 103T1561 510.5 1664 896z"
})));